import { Injectable } from "@angular/core";
import { AuthChangeEvent, AuthError, AuthResponse, AuthSession, AuthTokenResponsePassword, GoTrueClient, Session, Subscription, SupabaseClient, UserResponse, createClient } from "@supabase/supabase-js";
import { environment } from "../../../../environments/environment";

@Injectable({ providedIn: 'root' })
export class SupabaseService {
    private supabase!: SupabaseClient;
    private _session: AuthSession | null = null;

    public constructor() {
        this.supabase = createClient(environment.supabase.url, environment.supabase.key);
    }

    public get session() {
        this.supabase.auth.getSession().then(({ data }) => {
            this._session = data.session;
        });

        return this._session;
    }

    public authChanges(callback: (event: AuthChangeEvent, session: Session | null) => void): { data: { subscription: Subscription } } {
        return this.supabase.auth.onAuthStateChange(callback);
    }

    public login(email: string, password: string): Promise<AuthTokenResponsePassword> {
        return this.supabase.auth.signInWithPassword({
            email: email,
            password: password
        });
    }

    public logout(): Promise<{ error: AuthError | null }> {
        return this.supabase.auth.signOut();
    }

    public signup(email: string, password: string, username: string): Promise<AuthResponse> {
        return this.supabase.auth.signUp({
            email: email,
            password: password,
            options: {
                data: {
                    username: username
                }
            }
        });
    }

    public async verifyPasswordAsync(password: string): Promise<boolean> {
        const response = await this.supabase.rpc("verify_user_password", { password: password });
        console.debug(JSON.stringify(response));

        if (response.data == false) {
            return false;
        } else {
            return true;
        }
    }

    public async changePasswordAsync(oldPassword: string, newPassword: string): Promise<boolean> {
        if (newPassword.length < 8 || newPassword.length > 64) {
            return false;
        }

        if (oldPassword == newPassword) {
            return true;
        }

        const response = await this.supabase.auth.updateUser({ password: newPassword });

        if (response.error) {
            return false;
        } else {
            return true;
        }
    }

    public async resetPasswordAsync(newPassword: string): Promise<boolean> {
        if (newPassword.length < 8 || newPassword.length > 64) {
            return false;
        }

        const response = await this.supabase.auth.updateUser({ password: newPassword });

        if (response.error) {
            return false;
        } else {
            return true;
        }
    }

    public async changeUsernameAsync(newUsername: string, userId: string): Promise<boolean> {
        if (newUsername.length < 3 || newUsername.length > 64) {
            return false;
        }

        const response = await this.supabase.rpc("update_user_username", { username: newUsername, userid: userId});

        if (response.error) {
            return false;
        } else {
            return true;
        }
    }

    public async sendPasswordRecoveryEmailAsync(email: string): Promise<void> {
        await this.supabase.auth.resetPasswordForEmail(email, { redirectTo: "https://www.pondertcg.com/login/password-recovery" });
    }
}